
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.968.264C4.957.264.084 5.07.084 11c0 5.93 4.873 10.736 10.884 10.736 6.01 0 10.883-4.806 10.883-10.736C21.851 5.07 16.98.264 10.968.264zM6.084 10.338a.457.457 0 01.638-.05l3.675 3.098V4.365c0-.247.202-.446.452-.446s.452.2.452.446v8.916l3.027-2.97a.456.456 0 01.639.003.441.441 0 01-.002.63l-3.797 3.726a.454.454 0 01-.613.023l-4.42-3.726a.443.443 0 01-.05-.63zm10.101 6.499H5.514c-.25 0-.452-.2-.452-.446 0-.247.202-.446.452-.446h10.671c.25 0 .452.2.452.446a.449.449 0 01-.452.446z","fill":"#515358","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/home/photosForm/download.svg